import Editable from "../../Editable";
import InfoField from "../../InfoField";
import { useQuery } from "@apollo/client";
import PROFILE from "../../../api/queries/profile";
import UPDATE_PROFILE from "../../../api/mutations/updateProfile";
// import SPORTS from "../../../api/queries/sports";
import moment from "moment";
import Table from "../../Table";
import { FaTimes } from "react-icons/fa";
import { useAppState } from "../../../utils/appState";
import CreateEventRole from "./CreateEventRole";

function ProfileRoles({ profile }) {
  const [, setAppState] = useAppState();

  return (
    <Table
      config={{
        query: PROFILE,
        variables: {
          id: profile.id,
        },
        headerOptions: [
          () => (
            <div
              className="option"
              onClick={() => {
                setAppState({
                  modal: <CreateEventRole profileId={profile.id} />,
                });
              }}
            >
              Add
            </div>
          ),
        ],
        orderBy: [],
        search: () => {},
        fields: [
          { label: "Event", value: (row) => row.event.name, weight: 0.5 },
          {
            label: "Role",
            value: (row) => row.type.name,
            weight: 0.5,
          },
        ],
        itemOnClick: (history, item) => {
          // setAppState({
          //   modal: (
          //     <ViewRegistration eventRegistration={item} eventId={event.id} />
          //   ),
          // });
        },
        rows: (d) => d.profile.eventRoles,
        title: "",
      }}
    />
  );
}

export default ProfileRoles;
